import MyWorkspaceTable from '../MyWorkspaceTable';
import { useMemo } from 'react';
import { tablesLimit } from 'state/MyWorkspace/myWorkspaceSlice';
import { useSelector } from 'react-redux';
import Skelton from 'Atoms/Skelton/Skelton';

const ProjectsTableLoader = () => {
  const tableLimit = useSelector(tablesLimit);

  const rows = useMemo(() => {
    const projectsRows = [];
    for (let i = 0; i < tableLimit; i++) {
      projectsRows.push({
        className: 'table w-full table-fixed cursor-pointer',
        cells: [
          {
            content: <Skelton className='w-3/4 h-4' />,
          },
          {
            content: <Skelton className='w-7 h-2 rounded' />,
            className: 'w-16',
          },
          {
            content: <Skelton className='w-3/4 h-4' />,
            className: 'w-28',
          },
          {
            content: <Skelton className='w-3/4 h-4' />,
            className: 'w-36',
          },
        ],
      });
    }
    return projectsRows;
  }, [tableLimit]);

  return (
    <MyWorkspaceTable
      headCells={[
        {
          content: <Skelton />,
        },
        {
          content: '',
          className: 'w-16',
        },
        {
          content: <Skelton />,
          className: 'w-28',
        },
        {
          content: <Skelton />,
          className: 'w-36',
        },
      ]}
      rows={rows}
    />
  );
};

export default ProjectsTableLoader;
